import { Component, OnInit, Input } from '@angular/core';
import {Category} from '../../models/category';
import {Order} from '../../models/order';
import {OrderItem} from "../../models/order-item";


@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit {

  @Input() order: Order;
  @Input() menu: Category[];
  @Input() onAdd: (item) => void;

  today = new Date().getDay();
  categories: Category[];
  expandedCategory: string; // control for expanded category list to avoid close list when admin changes something in categories

  constructor() { }

  ngOnInit() {}

  toggleMenuCategory(menuCategory) {
    for (const category of this.menu) {
      if (menuCategory !== category) {
        category.expanded = false;
        this.expandedCategory = '';
      }
    }
    menuCategory.expanded = !menuCategory.expanded;
    if (menuCategory.expanded === true) {
      this.expandedCategory = menuCategory.title;
    }
  }

  add(item) {
    if (item.available) {
      this.onAdd(item);
    }
  }

  openImage(item: OrderItem, e) {
    e.preventDefault();
    e.stopPropagation();
    if (item.photoUrl) {
      /*this.lightbox.open([{
        src: item.picture,
        caption: item.description,
        thumb: ''
      }], 0);*/
    }
    return false;
  }

}
